import React, { useContext, useState, useEffect } from "react";
import SimpleBar from "simplebar-react";
import { Outlet } from "react-router-dom";
import Sidebar from "../Components/ui/sidebar";
import classes from "./Layout.module.scss";
import Navbar from "../Components/ui/navbar";
import { SideBarContextProvider } from "../store/sidebar-context";

export default function Layout() {
  return (
    <>
      <SideBarContextProvider>
        <div className={classes.layout}>
          <Sidebar />
          <SimpleBar style={{ maxHeight: "100vh", width: "100%" }}>
            <div className={classes.main}>
              <Navbar />
              <Outlet />
            </div>
          </SimpleBar>
        </div>
      </SideBarContextProvider>
    </>
  );
}
